import { render, staticRenderFns } from "./templateIndex.vue?vue&type=template&id=26f89545&scoped=true"
import script from "./templateIndex.vue?vue&type=script&lang=js"
export * from "./templateIndex.vue?vue&type=script&lang=js"
import style0 from "./templateIndex.vue?vue&type=style&index=0&id=26f89545&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26f89545",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26f89545')) {
      api.createRecord('26f89545', component.options)
    } else {
      api.reload('26f89545', component.options)
    }
    module.hot.accept("./templateIndex.vue?vue&type=template&id=26f89545&scoped=true", function () {
      api.rerender('26f89545', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dataAccess/questionnaire/templateIndex.vue"
export default component.exports